import { FileListItem } from '@views/documents/elements/FileList'

import { DmsDocument } from '../types'

export const mapDocumentToFileListItem = (document: DmsDocument): FileListItem => {
  const { id, name, uploadedAt, uploadedBy } = document

  return {
    id,
    type: 'document',
    name,
    addedAt: uploadedAt,
    addedBy: uploadedBy?.name ?? '',
  }
}
